import { applyCachedBrand } from '@crewdle/white-label';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { IMPERSONATION_NEXT_KEY, IMPERSONATION_TOKEN_KEY } from './app/pages/impersonate/impersonation-token';

// Capture the impersonation token from the URL fragment synchronously, before
// Angular's router runs. The /impersonate route is lazy-loaded, so the fragment
// can be cleared (router navigation during the chunk fetch) before the
// component's ngOnInit reads it. Stash it for the component to consume.
(() => {
  try {
    if (window.location.pathname !== '/impersonate') return;
    const hash = window.location.hash.replace(/^#/, '');
    const token = new URLSearchParams(hash).get('token');
    if (token) {
      sessionStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
      const next = new URLSearchParams(window.location.search).get('next');
      if (next) sessionStorage.setItem(IMPERSONATION_NEXT_KEY, next);
      else sessionStorage.removeItem(IMPERSONATION_NEXT_KEY);
      history.replaceState(null, '', '/impersonate');
    }
  } catch {
    // Non-fatal: the component falls back to reading the fragment itself.
  }
})();

// Re-apply the last-known partner brand from localStorage before Angular
// renders anything, so branded users don't see a flash of Crewdle defaults.
// The live Firestore read then confirms or replaces it.
applyCachedBrand();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
